import { ValidatorFn, Validators } from '@angular/forms';

export const phoneValidator : ValidatorFn[] = [Validators.required, Validators.pattern(/^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)]